import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "regenerator-runtime/runtime.js";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { useStore } from "vuex";
import staticData from "@/assets/data/dataScreen.json";
import { defineComponent, onMounted, reactive, ref, onBeforeUnmount, onUnmounted } from "vue";
export default defineComponent({
  name: "Mission",
  components: {},
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var total = ref(0);
    var missionNum = ref(0);
    var Data = reactive({
      tableData: []
    });
    var store = useStore();
    var inspectionLineHtmlMission = ref();
    var inspectionLineHtmlMissionWidth = ref();
    var missionTimer1;
    onMounted(function () {
      if (store.state.system.demonstration) {
        Data.tableData = staticData.missionData;
        total.value = 25;
        setLine();
        missionTimer1 = setTimeout(function () {
          start();
          clearTimeout(missionTimer1);
        }, 2000);
      } else {
        getList();
        missionTimer1 = setTimeout(function () {
          start();
          clearTimeout(missionTimer1);
        }, 2000);
      }
    });

    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getMissionDataScreen();

              case 2:
                _context.next = 4;
                return getMissionDataScreenTotal();

              case 4:
                setLine();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getList() {
        return _ref.apply(this, arguments);
      };
    }(); //绘制责任清单的横条


    function setLine() {
      var missionTimer = setTimeout(function () {
        inspectionLineHtmlMission.value = document.querySelectorAll(".inspectionLineMission");
        inspectionLineHtmlMissionWidth.value = document.getElementsByClassName("inspectionNumberMission");
        var maxWidth = inspectionLineHtmlMissionWidth.value[0].offsetWidth;
        var maxValue = 0;
        var fontNum = 0;

        if (inspectionLineHtmlMission.value) {
          Data.tableData.forEach(function (item) {
            if (Number(item.total) > maxValue) {
              maxValue = Number(item.total);
              fontNum = item.total.length;
            }
          });
          Data.tableData.forEach(function (item) {
            var len = inspectionLineHtmlMission.value.length;

            for (var i = 0; i < len; i++) {
              var dataset = inspectionLineHtmlMission.value[i].dataset;

              if (dataset.linenum == item.id) {
                inspectionLineHtmlMission.value[i].style.width = Number(item.total) / maxValue * (maxWidth - fontNum * 14) + "px";
              }
            }
          });
        }

        clearTimeout(missionTimer);
      }, 0);
    } // 责任清单


    var getMissionDataScreen = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMissionDataScreen"]();

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  Data.tableData = res.data;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getMissionDataScreen() {
        return _ref2.apply(this, arguments);
      };
    }(); //总数


    var getMissionDataScreenTotal = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMissionDataScreenTotal"]();

              case 2:
                res = _context3.sent;

                if (res.code == 0) {
                  total.value = res.data;
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getMissionDataScreenTotal() {
        return _ref3.apply(this, arguments);
      };
    }();

    var timer = ref();
    onBeforeUnmount(function () {
      //清除定时器
      clearInterval(timer.value);
    });

    function testMoveMission() {
      clearInterval(timer.value);
    }

    function testMendMission() {
      start();
    }

    function testMoveMissionLine(res) {
      missionNum.value = res.total;
      Data.tableData.forEach(function (item) {
        if (item.id == res.id) {
          item.show = true;
        }
      });
    }

    function testMendMissionLine(res) {
      Data.tableData.forEach(function (item) {
        if (item.id == res.id) {
          item.show = false;
        }
      });
    }

    function start() {
      //清除定时器
      clearTimeout(timer.value); //定时器触发周期

      var speed = ref(50);
      timer.value = setInterval(MarqueeTest, speed.value);
    }

    var rollHtml = ref();

    function MarqueeTest() {
      rollHtml.value = document.getElementsByClassName("rollActivity");
      var testMisson = rollHtml.value[0];

      if (testMisson && testMisson.offsetHeight == 0) {
        testMisson = rollHtml.value[0];
      } else {
        //如果列表数量过少不进行滚动
        if (testMisson && testMisson.children.length < 8) {
          clearInterval(timer.value);
          return;
        }

        testMisson.scrollTop += 1;

        if (testMisson.scrollTop == testMisson.scrollHeight - testMisson.clientHeight) {
          var a = testMisson.children[0];
          testMisson.removeChild(a);

          if (Data.tableData.length % 2 == 1) {
            a.className = a.className == "bot-bot" ? "blue bot-bot" : "bot-bot";
          }

          testMisson.append(a);
        }
      }
    }

    var timerTask;

    var taskGet = function taskGet() {
      timerTask = setInterval(function () {
        getList(); // clearInterval(timerTask);
        // taskGet();
      }, 10000);
    };

    if (!store.state.system.demonstration) {
      taskGet();
    }

    onUnmounted(function () {
      //清除定时器（列表滚动的）
      clearInterval(timer.value); //清除轮训的定时器

      clearInterval(timerTask);
      clearTimeout(missionTimer1);
    });
    return {
      Data: Data,
      total: total,
      missionNum: missionNum,
      testMoveMission: testMoveMission,
      testMendMission: testMendMission,
      testMoveMissionLine: testMoveMissionLine,
      testMendMissionLine: testMendMissionLine,
      rollHtml: rollHtml,
      inspectionLineHtmlMission: inspectionLineHtmlMission,
      getList: getList,
      getMissionDataScreenTotal: getMissionDataScreenTotal,
      getMissionDataScreen: getMissionDataScreen,
      setLine: setLine
    };
  }
});